import { combineReducers } from 'redux'

import { entitiesCreators } from 'store/common'

import * as reducersNames from 'utils/enums/reducersNames'

export const listsNames = [reducersNames.REDUCER_NAME_FEEDBACK_FORMS]

export const listsReducers = listsNames
  .sort()
  .reduce((reducers, name) => ({ ...reducers, [name]: entitiesCreators.createStoreEntityList(name) }), {})

export default combineReducers(listsReducers)
